import { render } from "./TheVehicleModelCreation.vue?vue&type=template&id=3685acb8"
import script from "./TheVehicleModelCreation.vue?vue&type=script&lang=js"
export * from "./TheVehicleModelCreation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__